/**
 * The browser never submits a form of this app itself. Every form handles its own submit
 * in React (onSubmit, then a save or a navigation). But while a route change runs in a view
 * transition, React does not handle events on the page being left, and an Enter still held
 * there reaches the browser alone: its own submission would reload the page with the
 * form's fields (a NIK, a PIN) in the address, and so in the history. One listener on
 * `window`, installed before anything renders, cancels that submission for every form,
 * including one mounted a moment ago. It listens in the bubble phase, so it runs after
 * React's root listener: React and react-router see the submit before it is prevented (a
 * router `<Form>` or `fetcher.Form` skips a submit already prevented, and so would a React
 * 19 form `action`), and a submission React missed is still cancelled here. A React
 * handler that stops the propagation has handled the submit itself. It only prevents the
 * default and stops nothing. Pure: the caller hands in the target (`window`).
 */

export interface TargetKirim {
  addEventListener(
    type: 'submit',
    fn: (event: { preventDefault(): void }) => void,
    capture: boolean,
  ): void
}

export function pasangTahanKirimAsli(target: TargetKirim): void {
  target.addEventListener(
    'submit',
    (event) => {
      event.preventDefault()
    },
    false,
  )
}
